import {
  BusinessPlaylistsList,
  processPlaylistsToPlaylistDescriptors,
} from 'components/profile/playlists/BusinessPlaylistsDialogListsPage';
import { Divider, IconButton } from 'omakase';
import { Grid } from 'ui';
import { IconEllipses } from '@tock/icons';
import { consumer } from '@tock/coretypes';
import { keyBy } from 'es-toolkit/compat';
import { useHistory, useLocation } from 'react-router';
import { useInitializePlaylistDefaults, useSharePlaylist } from 'hooks/useLoadPlaylists';
import { useMemo, useState } from 'react';
import EditPlaylistDialog from './EditPlaylistDialog';
import PlaylistOptionsDialog from './PlaylistOptionsDialog';

interface Props {
  playlists: consumer.Playlist[];
}

const ProfilePlaylistsList: React.FunctionComponent<Props> = ({ playlists }) => {
  const history = useHistory();
  const location = useLocation();
  const [isOptionsOpen, setIsOptionsOpen] = useState<
    { isOpen: false } | { isOpen: true; playlist: consumer.Playlist }
  >({ isOpen: false });
  const [isDetailsOpen, setIsDetailsOpen] = useState<
    { isOpen: false } | { isOpen: true; playlist: consumer.Playlist }
  >({ isOpen: false });

  const playlistDescriptors = useMemo(() => {
    return processPlaylistsToPlaylistDescriptors(playlists);
  }, [playlists]);
  const onClick = (playlistId: number) => {
    history.push(`${location.pathname}/${playlistId}`);
  };
  const playlistIdToPlaylist = keyBy(playlists, (playlist) => playlist.id);
  const handleSharePlaylist = useSharePlaylist();

  useInitializePlaylistDefaults(playlistDescriptors);

  return (
    <>
      {playlistDescriptors.map((playlist) => {
        const actionComponent = (
          <IconButton
            variant="ghost"
            size="medium"
            aria-label="Menu"
            onClick={() =>
              setIsOptionsOpen({ isOpen: true, playlist: playlistIdToPlaylist[playlist.id] })
            }
          >
            <IconEllipses />
          </IconButton>
        );
        return (
          <Grid container spacing={2} key={`playlist-${playlist.id}`}>
            <Grid item xs={12}>
              <BusinessPlaylistsList
                onClick={onClick}
                playlist={playlist}
                actionComponent={actionComponent}
              />
            </Grid>

            <Grid item xs={12}>
              <Divider />
            </Grid>
          </Grid>
        );
      })}
      <PlaylistOptionsDialog
        isOpen={isOptionsOpen.isOpen}
        playlist={isOptionsOpen.isOpen ? isOptionsOpen.playlist : undefined}
        onClose={() => setIsOptionsOpen({ isOpen: false })}
        onDeleteListDone={() => setIsOptionsOpen({ isOpen: false })}
        onEditListDetails={() => {
          isOptionsOpen.isOpen &&
            setIsDetailsOpen({ isOpen: true, playlist: isOptionsOpen.playlist });
          setIsOptionsOpen({ isOpen: false });
        }}
        onShareList={() => {
          isOptionsOpen.isOpen && handleSharePlaylist(isOptionsOpen.playlist);
          setIsOptionsOpen({ isOpen: false });
        }}
      />
      <EditPlaylistDialog
        isOpen={isDetailsOpen.isOpen}
        onClose={() => setIsDetailsOpen({ isOpen: false })}
        playlist={isDetailsOpen.isOpen ? isDetailsOpen.playlist : undefined}
      />
    </>
  );
};

export default ProfilePlaylistsList;
